module.exports = __webpack_public_path__ + "e7a04da2.woff";